import React from 'react';

export const withInputClassNames = Input => props => (
  <Input
    {...props}
    containerClassName="w-100"
    labelClassName="text-gray-light t-14 form-label"
    inputClassName="form-control t-15"
  />
);

export const withTextAreaClassNames = Input => props => (
  <Input
    {...props}
    containerClassName="w-100"
    labelClassName="text-gray-light t-14 form-label"
    inputClassName="form-control t-15"
    type="textArea"
  />
);

export const withDropdownClassNames = Dropdown => props => (
  <Dropdown
    {...props}
    containerClassName="w-100"
    labelClassName="text-gray-light t-14 form-label"
    arrowClassName="edit-profile__content-dropdown-icon"
    dropdownClassName="edit-profile__content-dropdown"
  />
);



// WEBPACK FOOTER //
// ./src/components/EditProfile/HOC/index.js